import React from "react";
import Swal from "sweetalert2";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {Link, useNavigate} from "react-router-dom";
import * as Yup from "yup";

//import ModalAgregarContendor from "./ModalAgregarContenedor";
import {CampoSelect} from "../../../../helpers/CampoSelect";
import {CampoSelectAsync} from "../../../../helpers/CampoSelectAsync.js";
import {createSolicitud, getAllNavierasSolicitud} from "../../../../helpers/Api";

const FormatoDeSolicitud = () => {
  
  //ROUTER
  const token = localStorage.getItem('token');
  const idAgencia = localStorage.getItem('agencia');
  const navigate = useNavigate();

  let initialValues = {
    referencia: "",
    numero_bl: "",
    rfc: "",
    cliente: "",
    fecha_eta: "",
    fecha_revalidacion: "",
    naviera: "",
    convenio_colaboracion: {value: true, label: 'Aplica convenio'},
  };

  const getAllNavieras = async (search) => {
    try {
      const response = await getAllNavierasSolicitud(search, token);
      if (response) {
        return response
      }
    } catch (error) {
      throw error
    }
  }

  const handlerCreateSolicitud = async (values, resetForm) => {
    try {
      const response = await createSolicitud({
        referencia: values.referencia,
        numero_bl: values.numero_bl,
        rfc: values.rfc,
        cliente: values.cliente,
        fecha_eta: values.fecha_eta,
        naviera: values.naviera.original_value.clave,
        fecha_revalidacion: values.fecha_revalidacion,
        convenio_colaboracion: values.convenio_colaboracion.value,
        agencia_aduanal_id: idAgencia,
      }, token);
      if (response) {
        Swal.fire("Exito", "La solicitud es creada ", "success");
        resetForm();
        navigate(`/detalle-operaciones/${response.id}/#contenedores`);
      }
    } catch (error) {
        Swal.fire(
          "Oops",
          `Ha surgido un problema en guardar la solicitud, <br />
          Consejo: ${error.response.status === 403 ? 'Su usuario está pausado, comuniquese con el administrador de la AAAVER'  : error.response.data[0]   }
          `,
          "error"
        );
      }
    };




  //Convenio de Colaboracion
  const aplicaConvenio = [
    { value: true, label: "Aplica convenio" },
    { value: false, label: "No aplica convenio" },
  ];

  return (
    <div className="row mb-5">
      <div className="col-12">
        <div className="card card_form">
          <Formik
            initialValues={initialValues}
            validationSchema={Yup.object().shape({
              referencia: Yup.string().required("Campo requerido"),
              numero_bl: Yup.string().required("Campo requerido"),
              rfc: Yup.string().required("Campo requerido"),
              cliente: Yup.string().required("Campo requerido"),
              naviera: Yup.object().required("Campo requerido"),
              fecha_eta: Yup.date().required("Campo requerido"),
              fecha_revalidacion: Yup.date().test(
                'fecha_logic',
                'La fecha de revalidación no puede ser menor a cinco días de la fecha de atraque.',
                function(value){
                  const { fecha_eta } = this.parent;
                  const fiveDaysBefore = new Date(fecha_eta);
                  fiveDaysBefore.setDate(fiveDaysBefore.getDate() - 6);
                  return value > fiveDaysBefore
                }
              ).required('campo requerido'),
            })}
            onSubmit={(values, { resetForm }) => {
              handlerCreateSolicitud(values, resetForm);
            }}
          >
            {(props) => (
              <Form>
                <>
                  <div className="row">
                    <h6>Formato de solicitud</h6>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Referencia
                      </label>
                      <Field
                        type="text"
                        name="referencia"
                        className="form-control"
                      />
                      <ErrorMessage name="referencia" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Número de BL
                      </label>
                      <Field
                        type="text"
                        name="numero_bl"
                        className="form-control"
                      />
                      <ErrorMessage name="numero_bl" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Cliente
                      </label>
                      <Field
                        type="text"
                        name="cliente"
                        className="form-control"
                      />
                       <ErrorMessage name="cliente" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        RFC del Cliente
                      </label>
                      <Field 
                      type="text" 
                      name="rfc"
                      onKeyUp={e  => e.target.value.toUpperCase()}
                      value={props.values.rfc.toUpperCase()}
                      className="form-control" />
                       <ErrorMessage name="rfc" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Fecha de Atraque
                      </label>
                      <Field
                        type="date"
                        onChange={(value) => props.setFieldValue('fecha_eta', value.target.value)}
                        name="fecha_eta"
                        className="form-control"
                      />
                       <ErrorMessage name="fecha_eta" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                      Fecha de revalidación
                      </label>
                      <Field
                        type="date"
                        onChange={(value) => props.setFieldValue('fecha_revalidacion', value.target.value)}
                        name="fecha_revalidacion"
                        className="form-control"
                      />
                      <ErrorMessage name="fecha_revalidacion" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Naviera
                      </label>
                      <CampoSelectAsync
                        blank={false}
                        name="naviera"
                        fieldShow="nombre" 
                        selectedValue={props.values["naviera"]} 
                        remoteCall={getAllNavieras}
                        onChange={props.setFieldValue} 
                        placeholder="Seleccione naviera"                        
                        />
                      <ErrorMessage name="naviera" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Convenio de Colaboración
                      </label>
                      <CampoSelect
                        type="text"
                        name={"convenio_colaboracion"}
                        valores={aplicaConvenio}
                        value={props.values}
                        onChange={props.setFieldValue}
                        selectedValue={props.values.convenio_colaboracion}
                        className="form-control"
                        placeholder="Seleccione el tipo de convenio"
                      />
                      <ErrorMessage name="convenio_colaboracion" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col-12">
                      <div className="d-flex flex-row-reverse cta_solicitud">
                        <button
                          className="btn"
                          type="submit"
                          style={{ backgroundColor: "#1F107D", width: "8rem" }}
                        >
                          Crear
                        </button>

                        <Link to="/">
                          <button
                            className="btn"
                            type="button"
                            style={{
                              backgroundColor: "#F47777",
                              width: "8rem",
                            }}
                          >
                            Regresar
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default FormatoDeSolicitud;
